export type SportCategory = 'team' | 'individual';

const INDIVIDUAL_SPORTS = new Set<string>(['pickleball', 'golf', 'tennis']);

export function getSportCategory(sport: string | null | undefined): SportCategory {
  return sport && INDIVIDUAL_SPORTS.has(sport) ? 'individual' : 'team';
}

export function isIndividualSport(sport: string | null | undefined): boolean {
  return getSportCategory(sport) === 'individual';
}
